import { useI18n } from 'builder/hooks/useI18n'
import CheckCircle from './CheckCircle.svg'

import { Expert, Icon, TextContainer, Title, Wrapper } from './styles'

interface Props {
  onClick: (e: React.MouseEvent) => void
}

export const CritiqueReview = (props: Props) => {
  const { i18n } = useI18n()

  return (
    <Wrapper onClick={props.onClick}>
      <TextContainer>
        <Icon src={CheckCircle} />
        <Title>{i18n.t('builder.dashboard.critique_review.title')}</Title>
      </TextContainer>
      <Expert>{i18n.t('builder.dashboard.critique_review.expert')}</Expert>
    </Wrapper>
  )
}
